import { createVanIconComponent } from "./van"

const VideoOutlined = createVanIconComponent("video-o")
export default VideoOutlined
